module.exports = __webpack_public_path__ + "static/media/Hair_1_dark_brown.8cc23a69.svg";